// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-title__text[data-v-01dff066]{font-weight:700;font-size:24px;line-height:40px;letter-spacing:0}.close-dialog__icon[data-v-01dff066]{cursor:pointer;align-self:start}[data-v-01dff066] .v-toolbar__content{padding-right:0}.dialog-box-ok__btn[data-v-01dff066]{max-width:160px;border-radius:35px;font-size:13px}.dialog-box-cancel__btn[data-v-01dff066]{border-radius:35px;text-decoration:underline;font-size:13px;font-weight:700;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
